var render, staticRenderFns
import script from "./carousel-eigentumer.vue?vue&type=script&lang=js&"
export * from "./carousel-eigentumer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c7aafc')) {
      api.createRecord('68c7aafc', component.options)
    } else {
      api.reload('68c7aafc', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-8JzuhB2N9G6vH/JS/comp/carousel-eigentumer.vue"
export default component.exports